import React from 'react';
import PropTypes from 'prop-types';
import { Image as RImage, Box } from 'rebass';
import styled from 'styled-components';
import { display } from 'styled-system';

import { SPACE } from 'Components/Theme';

const Image = styled(RImage)`
  ${display};
`;

const BannerMobile = props => <Image {...props} display={['block', 'block', 'none']} />;
const BannerTablet = props => <Image {...props} display={['none', null, 'block', 'none']} />;
const BannerDesktop = props => <Image {...props} display={['none', null, null, 'block']} />;
const Banner = ({ images, onClick, ...rest }) => {
  const hrefProps = typeof onClick === 'function' ? { is: 'a', href: '#' } : {};
  return images ? (
    <Box {...hrefProps} onClick={onClick} style={{ display: 'block' }} mb={SPACE.large} {...rest}>
      {images.mobile && <BannerMobile src={images.mobile} />}
      {images.tablet && <BannerTablet src={images.tablet} />}
      {images.desktop && <BannerDesktop src={images.desktop} />}
    </Box>
  ) : null;
};

Banner.propTypes = {
  images: PropTypes.shape({
    mobile: PropTypes.string,
    tablet: PropTypes.string,
    desktop: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

Banner.defaultProps = {
  images: {},
};

export default Banner;
